"use client";
import { useIsMobile } from '@/hooks/use-mobile';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel';
import Autoplay from 'embla-carousel-autoplay';
const logo1 = '/assets/logos/logo-1.svg';
const logo2 = '/assets/logos/logo-2.webp';
const logo3 = '/assets/logos/logo-3.webp';
const logo4 = '/assets/logos/logo-4.svg';
const logo5 = '/assets/logos/logo-5.svg';
const logo6 = '/assets/logos/logo-6.webp';
const logo7 = '/assets/logos/logo-7.webp';
const logo8 = '/assets/logos/logo-8.webp';
const logo9 = '/assets/logos/logo-9.webp';
const logo10 = '/assets/logos/logo-10.webp';
const logo11 = '/assets/logos/logo-11.svg';
const logo12 = '/assets/logos/logo-12.svg';
const logo13 = '/assets/logos/logo-13.svg';
const logo14 = '/assets/logos/logo-14.webp';
const logo15 = '/assets/logos/logo-15.webp';

// Alt text = the customer's name, read off each logo. It used to be "Partner 1-15",
// which told crawlers (and screen readers) nothing about who the customers are.
// logo-1 is an unlabeled icon, so it stays decorative (alt="") until it's identified.
const logos = [
  { src: logo1, alt: '', width: 48, height: 48 },
  { src: logo2, alt: 'Ayb School', width: 90, height: 48 },
  { src: logo3, alt: 'Central Bank of Armenia', width: 203, height: 48 },
  { src: logo4, alt: 'Coffee House', width: 85, height: 40 },
  { src: logo5, alt: 'Ameriabank', width: 306, height: 48 },
  { src: logo6, alt: 'Ardshinbank', width: 162, height: 48 },
  { src: logo7, alt: 'American University of Armenia', width: 102, height: 48 },
  { src: logo8, alt: 'ACBA', width: 133, height: 48 },
  { src: logo9, alt: 'Byblos Bank Armenia', width: 89, height: 40 },
  { src: logo10, alt: 'EasyPay', width: 196, height: 40 },
  { src: logo11, alt: 'FINCA', width: 145, height: 48 },
  { src: logo12, alt: 'ONEX', width: 161, height: 48 },
  { src: logo13, alt: 'Telcell', width: 265, height: 48 },
  { src: logo14, alt: 'Public Television of Armenia', width: 151, height: 48 },
  // Named as in its customer story ("Ingo Insurance"); the artwork only shows "INGO".
  { src: logo15, alt: 'Ingo Insurance', width: 156, height: 48 },
];

const allLogos = [...logos, ...logos];

export function LogoMarquee() {
  const isMobile = useIsMobile();

  return (
    <section className="pt-16 pb-8 bg-muted/20 border-t overflow-hidden isolate">
      <div className="container mx-auto mb-8">
        <p className="text-center text-sm font-semibold text-muted-foreground uppercase tracking-wider">
          Trusted by 1,000+ leading companies worldwide
        </p>
      </div>

      {isMobile ? (
        <div className="px-4">
          <Carousel
            plugins={[Autoplay({ delay: 2000, stopOnInteraction: false })]}
            opts={{ loop: true, align: 'start' }}
            className="w-full"
          >
            <CarouselContent className="-ml-2">
              {logos.map((logo, index) => (
                <CarouselItem
                  key={`mobile-${logo.alt}-${index}`}
                  className="basis-1/3 pl-2 flex items-center justify-center"
                >
                  <img
                    src={logo.src}
                    alt={logo.alt}
                    width={logo.width}
                    height={logo.height}
                    loading="lazy"
                    decoding="async"
                    className="h-8 w-auto max-w-[100px] object-contain grayscale opacity-60"
                  />
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
        </div>
      ) : (
        <div className="relative">
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-muted/20 to-transparent z-10" />
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-muted/20 to-transparent z-10" />

          <div className="flex gap-16 items-center animate-[marquee_30s_linear_infinite]">
            {allLogos.map((logo, index) => (
              <div
                key={`${logo.alt}-${index}`}
                className="flex-shrink-0 flex items-center justify-center h-12 grayscale hover:grayscale-0 opacity-60 hover:opacity-100 transition-all duration-300"
              >
                {/* The second copy only makes the loop seamless: keep it out of the text. */}
                <img
                  src={logo.src}
                  alt={index < logos.length ? logo.alt : ''}
                  aria-hidden={index >= logos.length || undefined}
                  width={logo.width}
                  height={logo.height}
                  className="h-10 w-auto max-w-[130px] object-contain"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}
